import { apolloClient } from '~/apollo-client';

import {
  Flex_UpdateUserMutation,
  Flex_UpdateUserMutationVariables,
  UserOriginationSourceInput,
} from '~/typings/graphql';
import { UPDATE_ORIGINATION_SOURCE_FUNNEL } from './update-origination-source-funnel.queries';

export const updateOriginationSource = async (
  userId,
  funnel?,
  enrollmentExperience?,
  queryParams?,
) => {
  const originationSourceAttributes: UserOriginationSourceInput = {
    funnel,
    queryParams,
  };

  if (funnel) {
    originationSourceAttributes.funnel = funnel;
  }
  if (enrollmentExperience) {
    originationSourceAttributes.enrollmentExperience = enrollmentExperience;
  }
  await apolloClient.mutate<Flex_UpdateUserMutation, Flex_UpdateUserMutationVariables>({
    mutation: UPDATE_ORIGINATION_SOURCE_FUNNEL,
    variables: {
      id: userId,
      input: {
        originationSourceAttributes,
      },
    },
  });
};
